import { baseApi } from "@/config/http-common";
import { filemanagerApi } from "@/config/http-filemanager";

class DocumentTemplateDataService {
  getAll(params?: Record<string, unknown>): Promise<any> {
    return baseApi.get("/documents/document-template/list", { params });
  }

  get(id: any): Promise<any> {
    return baseApi.get(`/documents/document-template/view/${id}`);
  }

  create(data: any): Promise<any> {
    return baseApi.post("/documents/document-template/create", data);
  }

  update(id: any, data: any): Promise<any> {
    return baseApi.put(`/documents/document-template/update/${id}`, data);
  }

  delete(id: string, coordinatorId?: string): Promise<any> {
    return baseApi.delete(`/documents/document-template/delete/${id}`, {
      params: coordinatorId != null ? { coordinatorId } : undefined,
    });
  }

  convert(data: any): Promise<any> {
    return filemanagerApi.post("/convert", data);
  }
}

export default new DocumentTemplateDataService();
